
export class StyleModel {
    styleIdPk: string;
    styleName: string;
    styleDesc: string;
    targetEff: string;

    constructor(styleIdPk: string, styleName: string, styleDesc: string, targetEff: string) { 
        this.styleDesc = styleDesc;
        this.styleName = styleName;
        this.styleIdPk = styleIdPk;
        this.targetEff = targetEff;
    }
}